import React from 'react'

const Checkmark = ({ height = 30, width = 30, className = null }) => (
  <svg className={className} width={width} height={width} viewBox="0 0 36 36">
    <path d="M8.311 16.54a.919.919 0 0 1-.645-.266L.27 8.922a.921.921 0 0 1-.005-1.3.916.916 0 0 1 1.296-.005l6.7 6.661L20.392.316a.914.914 0 0 1 1.293-.09.92.92 0 0 1 .09 1.296L9.001 16.224a.91.91 0 0 1-.657.315H8.31l.001.001z"/>
  </svg>
)

export default Checkmark
